export class PageScroll {
	constructor() {
		window.addEventListener('scroll', this.updateBodyClass, { passive: true });
		this.updateBodyClass();
	}

	private updateBodyClass = () => {
		if (window.scrollY > 10) {
			document.body.classList.add('scroll-down');
		} else {
			document.body.classList.remove('scroll-down');
		}
	};
}
